export default __webpack_public_path__ + "static/media/640_dummy2016-ernaehrungsberatung.968a1393.png";